module.exports = __webpack_public_path__ + "static/media/googleplusicon.073c5de8.png";